<template>
  <div>
    <!-- <div class="debug text-xs max-w-6xl mx-auto !pl-10">
      routeName: {{ route.name }}
      <br>
      path: {{ route.fullPath  }}
      <br>
      category: {{ category?.title }}
      <br>
      city: {{ city?.name }}
      <br>
      isCity: {{ !!isCity }}
      <hr class="my-4">
      isCategory: {{ !!isCategory }}
      <br>
      isCategoryCity: {{ !!isCategoryCity }}
      <br>
      isPost: {{ !!isPost }}
    </div> -->
    <City v-if="isCity" />
    <Posts v-else-if="isCategory || isCategoryCity" />
    <Post v-else-if="isPost" />
  </div>
</template>

<script setup>
const route = useRoute()
const app = useAppStore()

// Check if path is city
const isCity = computed(() => app.cities?.find(city => city.slug === route.params?.all[0]) && route.params.all?.length === 1)

// Use config from app store to get category and city
const category = computed(() => app.categories?.find(cat => cat.slug === route.params.all[0]))
const city = computed(() => app.cities?.find(city => city.slug === route.params.all[1]))

// Check if route is a page or term
const isCategory = computed(() => category.value?.slug && route.params.all?.length === 1)
const isCategoryCity = computed(() => category.value?.slug && city.value?.slug && route.params.all?.length === 2)
const isPost = computed(() => route.params.all?.length)

// Dynamically import pages
const City = defineAsyncComponent(() => import('~/pages/city/index.vue'))
const Posts = defineAsyncComponent(() => import('~/pages/posts/index.vue'))
const Post = defineAsyncComponent(() => import('~/pages/posts/single.vue'))
</script>
